module.exports = __webpack_public_path__ + "static/img/five.99f7914.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/five.png
// module id = BX9r
// module chunks = 1